// extracted by mini-css-extract-plugin
export default {"hero":"Hero_hero__zvVCj","hero1":"Hero_hero1__QPXtH","hero_content_wrapper":"Hero_hero_content_wrapper__K5jwT","text_div":"Hero_text_div__PXSDv"};